import { IUser } from '@sparling/financial-common'
import { IColumns } from '../../../components/Table'

export type CommissionsColumnKeys =
  | 'transactionId'
  | 'referredUser'
  | 'receiverUser'
  | 'currency'
  | 'amount'
  | 'status'
  | 'createdAt'
  | 'checkbox'
  | 'actions'

export const columns: IColumns<CommissionsColumnKeys>[] = [
  {
    id: 'checkbox',
    label: '',
  },
  // {
  //   id: 'transactionId',
  //   label: 'TX ID',
  // },
  {
    id: 'referredUser',
    label: 'CLIENT',
    format: (value) => (value as IUser)?.name || '-',
  },
  {
    id: 'receiverUser',
    label: 'INTRODUCER',
    format: (value) => (value as IUser)?.name || '-',
  },
  {
    id: 'currency',
    label: 'ASSET',
  },
  {
    id: 'amount',
    label: 'AMOUNT',
  },
  {
    id: 'status',
    label: 'STATUS',
  },
  {
    id: 'createdAt',
    label: 'CREATED',
    format: (value) => (value ? new Date(value as Date).toLocaleString() : '-'),
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]
